import { cmApi, type SecurityMultipleDeviceRow } from '@/api/cmApi'
import { cheaterUsername, idChipList } from './securityUi'
import { SecurityCrudPage } from './SecurityCrudPage'

/** Live from Player-API via CM-API when PLAYER_API_URL is configured. */
export function MultipleDeviceIdsPage() {
  return (
    <SecurityCrudPage<SecurityMultipleDeviceRow>
      title="Multiple device IDs"
      subtitle="Portal players with more than one saved device id (Player-API)"
      queryKey="multiple-device"
      emptyHint="No players with multiple device ids. Data comes from Player-API saveDeviceId."
      listFn={cmApi.securityMultipleDeviceList}
      columns={[
        {
          key: 'user',
          header: 'Username',
          cell: (r) => cheaterUsername(r.username, r.isCheater),
        },
        { key: 'count', header: 'Count', cell: (r) => r.deviceCount },
        {
          key: 'ids',
          header: 'Device IDs',
          cell: (r) => idChipList(r.deviceIds),
        },
      ]}
    />
  )
}
